import passengerTypesEnum from './../../scripts/constants/passenger-types-enum';
import CurrencyValueUIModel from './currency-value';
class PricePerPassengerTypeMapUIModel {
  constructor(dataMap = {}) {
    this.ADULT = null;
    this.CHILD = null;
    this.INFANT = null;
    let currencyTotal = 0;
    Object.keys(dataMap).forEach(type => {
      const data = dataMap[type];
      switch (type) {
        case passengerTypesEnum.ADULT:
          currencyTotal = data.currencyValues.map(currency => new CurrencyValueUIModel(currency));
          this.ADULT = {
            quantity: data.quantity,
            currencyValues: currencyTotal,
            costUnit: data.priceUnit,
          };
          break;
        case passengerTypesEnum.CHILD:
          currencyTotal = data.currencyValues.map(currency => new CurrencyValueUIModel(currency));
          this.CHILD = {
            quantity: data.quantity,
            currencyValues: currencyTotal,
            costUnit: data.priceUnit,
          };
          break;
        case passengerTypesEnum.INFANT:
          currencyTotal = data.currencyValues.map(currency => new CurrencyValueUIModel(currency));
          this.INFANT = {
            quantity: data.quantity,
            currencyValues: currencyTotal,
            costUnit: data.priceUnit,
          };
          break;
      }
    });
  }
}

export default PricePerPassengerTypeMapUIModel;
